import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { Pressable, View } from "react-native";
import Svg, { Path } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { useEffect, useState } from "react";

import Accordion from "components/Accordion";
import { FlashList } from "@shopify/flash-list";
import ImageView from "../../src/image";
import Input from "components/Input";
import VText from "components/VText";

const SearchableDropDown = ({
    item,
    prefAnswers = [],
    setPrefAnswers = () => {},
    answerkey = "dropDown",
    index = 0,
    closeDropDown,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [top, setTop] = useState(76);

    const selectedOptions = prefAnswers?.[answerkey] || [];

    const rotate = useSharedValue(0);

    const animatedStyles = useAnimatedStyle(() => ({
        transform: [{ rotateZ: `${rotate.value}deg` }],
    }));

    useEffect(() => {
        if (closeDropDown) {
            setIsOpen((prev) => {
                rotate.value = withTiming(0);
                return false;
            });
        }
    }, [closeDropDown]);

    const onSearch = async (txt) => {
        let dat = item?.options?.filter((o) => o?.brandName?.toLowerCase()?.includes(txt?.toLowerCase()));
        setSearchResults(dat || []);
    };

    return (
        <Pressable
            style={{
                zIndex: 100,
                marginBottom: spV(16),
                width: "100%",
            }}
        >
            <VText
                text={item?.question}
                style={{
                    fontSize: fp(16),
                    paddingBottom: hp(16),
                    fontWeight: "500",
                }}
            />

            <Pressable
                style={{
                    backgroundColor: "white",
                    paddingVertical: hp(8),
                    paddingHorizontal: wp(16),
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flex: 1,
                    width: "100%",
                    borderWidth: 1,
                    borderColor: "rgba(33, 36, 39, 0.16)",
                }}
                onLayout={(event) => {
                    const { x, y, width, height } = event.nativeEvent.layout;
                    setTop(height);
                }}
                onPress={() => {
                    setIsOpen((prev) => {
                        if (prev) {
                            rotate.value = withTiming(0);
                            return false;
                        } else {
                            rotate.value = withTiming(180);
                            return true;
                        }
                    });
                }}
            >
                {selectedOptions?.length == 0 && <VText text={item?.question} />}
                {selectedOptions?.length > 0 && (
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            flexWrap: "wrap",
                            flex: 1,
                            width: "100%",
                        }}
                    >
                        {selectedOptions?.map((o, idx) => (
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    borderWidth: 1,
                                    borderColor: "rgba(0, 0, 0, 0.6)",
                                    marginRight: spH(8),
                                    padding: spV(8),
                                    paddingRight: 0,
                                    marginBottom: spV(8),
                                }}
                                key={idx}
                            >
                                <VText
                                    text={o?.brandName}
                                    style={{
                                        fontSize: fp(16),
                                        textTransform: "capitalize",
                                    }}
                                />
                                <Pressable
                                    style={{
                                        paddingHorizontal: spH(8),
                                    }}
                                    onPress={() => {
                                        setPrefAnswers((prev) => ({
                                            ...prev,
                                            [answerkey]: prefAnswers?.[answerkey]?.filter(
                                                (n) => o?.optionId != n?.optionId
                                            ),
                                        }));
                                    }}
                                >
                                    <Svg
                                        width="9"
                                        height="9"
                                        viewBox="0 0 9 9"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <Path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M3.40376 4.28468L0.328613 7.35983L1.2125 8.24371L4.28764 5.16856L7.36279 8.24371L8.24668 7.35983L5.17153 4.28468L8.24615 1.21006L7.36227 0.326172L4.28764 3.40079L1.21302 0.326172L0.32914 1.21006L3.40376 4.28468Z"
                                            fill="#212427"
                                        />
                                    </Svg>
                                </Pressable>
                            </View>
                        ))}
                    </View>
                )}
                <Animated.View style={animatedStyles}>
                    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <Path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.99997 8.29936L5.29933 7L12 13.7006L18.7006 7L20 8.29936L12 16.2994L3.99997 8.29936Z"
                            fill="#212427"
                        />
                    </Svg>
                </Animated.View>
            </Pressable>
            <Accordion
                style={{
                    position: "absolute",
                    top: top + 35,
                    zIndex: 100,
                    elevation: 100,
                    shadowColor: "rgba(0, 0, 0, 0.25)",
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.4,
                    shadowRadius: 4,
                    maxHeight: hp(500),
                }}
                viewKey="qwerty"
                isExpanded={isOpen}
            >
                <View
                    style={{
                        backgroundColor: "white",
                        maxHeight: hp(500),
                    }}
                >
                    <View
                        style={{
                            paddingHorizontal: spH(20),
                            paddingVertical: spV(16),
                            paddingBottom: 0,
                        }}
                    >
                        <Input
                            showIcon
                            inputContainerStyle={{
                                padding: spV(8),
                                marginBottom: spV(16),
                            }}
                            leftIcon={() => (
                                <View
                                    style={{
                                        paddingRight: spH(16),
                                    }}
                                >
                                    <Svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <Path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M15.331 17.0233C13.9147 18.069 18.3189 13.5766 17.0656 15.2843C17.097 15.2818 17.0388 15.3765 16.844 15.6138C16.844 15.6138 20.1911 18.9299 21.8341 20.6176C22.4045 21.2329 21.3753 22.4609 20.6761 21.8197C19.1883 20.3798 15.6676 16.8014 15.6622 16.7955L15.331 17.0233Z"
                                            fill="#212427"
                                            fill-opacity="0.6"
                                            stroke="#212427"
                                            stroke-opacity="0.6"
                                            stroke-width="0.2"
                                        />
                                        <Path
                                            d="M10.4128 18.6999C12.5664 18.679 14.6983 17.7893 16.2313 16.2781C18.052 14.4832 18.9896 11.8278 18.6626 9.29253C18.1022 4.94821 14.5218 2 10.3593 2C7.19662 2 4.12303 3.9734 2.77483 6.83485C1.74277 9.02558 1.74068 11.6705 2.77483 13.865C4.11341 16.7064 7.13682 18.6694 10.3053 18.6999C10.3413 18.6999 10.3773 18.6999 10.4128 18.6999ZM10.3141 17.3079C7.09793 17.2771 4.0971 14.796 3.50036 11.6151C3.07968 9.37262 3.87379 6.94581 5.5281 5.35324C7.45923 3.49329 10.4948 2.87053 13.0189 3.9246C15.277 4.86771 16.9673 7.0576 17.2788 9.47023C17.5456 11.5383 16.8017 13.7057 15.3397 15.1986C14.0572 16.5083 12.2586 17.29 10.404 17.3079C10.3739 17.3079 10.3442 17.3079 10.3141 17.3079Z"
                                            fill="#212427"
                                            fill-opacity="0.6"
                                            stroke="#212427"
                                            stroke-opacity="0.6"
                                            stroke-width="0.2"
                                        />
                                    </Svg>
                                </View>
                            )}
                            placeholder="Search..."
                            value={search}
                            onChangeText={(txt) => {
                                setSearch(txt);
                                onSearch(txt);
                            }}
                        />
                    </View>

                    <FlashList
                        data={search?.length > 0 ? searchResults : item?.options || []}
                        estimatedItemSize={100}
                        extraData={prefAnswers}
                        contentContainerStyle={{
                            paddingHorizontal: spH(20),
                            paddingVertical: spV(16),
                        }}
                        keyExtractor={(item, index) => index.toString()}
                        renderItem={({ item }) => {
                            const isSelected =
                                prefAnswers?.[answerkey]?.find((o) => o?.optionId == item?.optionId) || false;

                            return (
                                <Pressable
                                    style={{
                                        marginBottom: hp(12),
                                        borderColor: "rgba(33, 36, 39, 1)",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                    onPress={() => {
                                        setPrefAnswers((prev) => ({
                                            ...prev,
                                            [answerkey]: isSelected
                                                ? prefAnswers?.[answerkey]?.filter((o) => o?.optionId != item?.optionId)
                                                : [...(prefAnswers?.[answerkey] || []), item],
                                        }));
                                    }}
                                >
                                    {!isSelected && (
                                        <View
                                            style={{
                                                width: wp(20),
                                                height: wp(20),
                                                borderWidth: 1,
                                                borderColor: "rgba(0, 0, 0, 0.16)",
                                                borderRadius: 2,
                                                paddingLeft: spH(8),
                                            }}
                                        />
                                    )}
                                    {isSelected && (
                                        <View
                                            style={{
                                                width: wp(20),
                                                height: wp(20),
                                                borderWidth: 1,
                                                borderColor: "rgba(0, 0, 0, 0.16)",
                                                borderRadius: 2,
                                                backgroundColor: "rgba(33, 36, 39, 1)",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Svg
                                                width="11"
                                                height="9"
                                                viewBox="0 0 11 9"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <Path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M10.0999 1.57583L3.37032 8.30541L0 4.67584L1.37399 3.39999L3.42033 5.60375L8.77408 0.25L10.0999 1.57583Z"
                                                    fill="white"
                                                />
                                            </Svg>
                                        </View>
                                    )}

                                    <VText
                                        text={item?.brandName?.slice(0, 30) || ""}
                                        style={{
                                            fontSize: fp(12),
                                            textAlign: "center",
                                            paddingLeft: spH(8),
                                        }}
                                        numberOfLines={1}
                                    />
                                </Pressable>
                            );
                        }}
                    />
                </View>
            </Accordion>
        </Pressable>
    );
};

export default SearchableDropDown;
